export function effectivePaymentStatus(row, asOfDate) {
  if (!row) return ''
  if (row.status === 'OVERDUE' || (row.status === 'PENDING' && row.dueAt && asOfDate && String(row.dueAt).slice(0, 10) < asOfDate)) return 'OVERDUE'
  return row.status
}

export function paymentStatusLabel(row, asOfDate) {
  const status = effectivePaymentStatus(row, asOfDate)
  return { PENDING: '待回款', PAID: '已回款', OVERDUE: '逾期' }[status] || status
}
